import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { StatusPill } from "@/components/StatusPill";
import { useI18n } from "@/i18n/I18nContext";
import { BookOpen, Loader2 } from "lucide-react";

const TYPE_COLOR = { FACT: "#38BDF8", STRATEGY: "#60A5FA", DECISION: "#6EE7B7", PREFERENCE: "#FCD34D", RESEARCH: "#A5B4FC" };

export default function Knowledge() {
  const [items, setItems] = useState(null);
  const { t } = useI18n();
  useEffect(() => { api.knowledge().then(setItems); }, []);
  if (!items) return <div className="flex items-center justify-center py-32"><Loader2 className="animate-spin text-[#2563EB]" /></div>;
  return (
    <div className="space-y-6">
      <div>
        <p className="mono-label">COMPANY MEMORY · CURATED BY KALA (AG013)</p>
        <h1 className="font-display text-3xl font-extrabold text-white mt-1 flex items-center gap-2"><BookOpen className="text-[#2563EB]" /> {t("kn.title")}</h1>
        <p className="text-sm text-[#94A3B8] mt-1">{t("kn.subtitle")}</p>
      </div>
      {items.length === 0 ? <div className="m-card p-10 text-center text-[#64748B] text-sm">{t("kn.empty")}</div> : (
        <div className="grid sm:grid-cols-2 gap-4">
          {items.map((k) => (
            <div key={k.id} className="m-card p-5" data-testid={`knowledge-${k.id}`}>
              <div className="flex items-center justify-between"><span className="m-pill" style={{ color: TYPE_COLOR[k.type] || "#94A3B8", borderColor: "#1E293B", background: "#0B0F19" }}>{k.type}</span><span className="mono-label">{k.scope} · {k.project_code || "COMPANY"}</span></div>
              <p className="text-white font-semibold mt-3">{k.title}</p>
              <p className="text-sm text-[#94A3B8] mt-1">{k.body}</p>
              <div className="mt-3 pt-3 border-t border-[#1E293B] flex items-center justify-between"><span className="text-[10px] text-[#64748B] font-mono">{t("kn.curatedBy", { v: k.curated_by })}</span><StatusPill status="APPROVED" label={k.status} /></div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
